// src/data/staticData.ts
export const countries = [
    { abbr: "US", code: "🇺🇸", name: "United States" },
    { abbr: "CN", code: "🇨🇳", name: "China" },
    // Add more countries as needed
  ];
  
  interface Game {
    component: string;
    symbol: string;
  }

  interface Games {
    [key: string]: Game[]; // Allows indexing with string keys
  }
  
  export const games: Games = {
    US: [
      { component: "num_range_0_10", symbol: "🔢 (0-10)" },
      { component: "num_range_0_100", symbol: "🔢 (0-100)" },
      { component: "math_easy", symbol: "➕➖" },
      { component: "math_normal", symbol: "➕➖\n✖️➗" },
      { component: "phone_numbers", symbol: "📞🔢" },
    ],
    CN: [
      { component: "num_range_0_10", symbol: "🔢 (0-10)" },
      { component: "num_range_0_100", symbol: "🔢 (0-100)" },
      { component: "math_easy", symbol: "➕➖" },
      { component: "math_normal", symbol: "➕➖\n✖️➗" },
      { component: "phone_numbers", symbol: "📞🔢" },
      { component: "time_of_day", symbol: "🕔" },
    ],
  };


  export const funFacts = {
    phone_numbers: {
      US: `<p>Phone numbers in the US are displayed as:</p>
  
  <p>(###) ###-####</p>
  
  <p>Where the first 3 digits are an area code related to where the user first registered their phone number. For people raised in the US, this will typically be their hometown, and for others, it will be the first place they lived in the US.</p>`,
      CN: `<p>The number "1" in Mandarin Chinese is typically pronounced as "yi1", but in a phone number, it is pronounced as "yao1".</p>
  
  <p>Mobile phone numbers in China are typically written in the following format:</p>
  
  <p>1## #### ####</p>
  
  <p>Where the first 3 digits are a carrier code that starts with 1.</p>
  
  <p>When spoken, sometimes people will say the number as it's written (3 digits, pause, 4 digits, pause, 4 digits), but sometimes it will be 3-3-5. In this game, you'll hear both ways that people say it.</p>`
    },
    math_easy: {
      CN: `<p>The number "1" in Mandarin Chinese is typically pronounced as "yi1", but in a phone number, it is pronounced as "yao1".</p>`
    },
    num_range_0_10: {
      CN: `<p>All base digits in Chinese are only 1 syllable, so they're typically spoken very quickly. Listen carefully!</p>
      
      <p>You can learn the numbers from 0-10 here: <a href="https://www.youtube.com/watch?v=2eLP3FuuEVs" target="_blank">https://www.youtube.com/watch?v=2eLP3FuuEVs</a>`
    },
    num_range_0_100: {
      CN: `<p>The numbers from 10-19 follow the format "十#", so 11 is "shi2 yi1", 16 is "shi2 liu6", etc.</p>
      
      <p>There's no tricks for 20-99 either, with them all following the format "#十#" So 22 is "er4 shi2 er4", 45 is "si4 shi2 wu3", etc.</p>
      
      <p> Once you get to 100, it is 一百 yi1 bai3.</p>`
    },
    time_game: {
      CN: `<p>Work in progress -- instructions for Time Game in Chinese</p>`
    },
  };